import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Form,
  FormGroup,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  Progress,
  Button
} from "components";

import moment from "moment";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLastfmSquare } from "@fortawesome/free-brands-svg-icons";
import * as faceapi from "face-api.js";
import {Camera} from "react-camera-pro";
import styled from 'styled-components';
import canvas from "canvas";
import { newUUID } from "jssip/lib/Utils";
import imageCompression from 'browser-image-compression';

// This function extract a face from video frame with giving bounding box and display result into outputimage
// const extractFaceFromBox = async (inputImage, regionsToExtract) => { 
//   // const regionsToExtract = [
//   //     new faceapi.Rect( box.x, box.y , box.width , box.height)
//   // ]
//   let faceImages = await faceapi.extractFaces(inputImage, regionsToExtract);
//   if (faceImages.length == 0){
//     console.log("Face not found");
//   } else {
//     faceImages.forEach(cnv =>{
//       outputImage.src = cnv.toDataURL();
//     });
//   }
// }
const videoRef = React.createRef();
const canvasRef = React.createRef();
const imageRef = React.createRef();
const camera = React.createRef();
 // Face directions
const CENTER_CENTER = "centercenter";
const CENTER_TOP = "centertop";
const CENTER_BOTTOM = "centerbottom";
const RIGHT_CENTER = "rightcenter";
const RIGHT_TOP = "righttop";
const RIGHT_BOTTOM = "rightbottom";
const LEFT_CENTER = "leftcenter";
const LEFT_TOP = "lefttop";
const LEFT_BOTTOM = "leftbottom";
const HAPPY = "happy";

// Login statuses
const WAITING_FACE = "waiting-face";
const RECOGNIZING_FACE = "recognizing-face";
const ERROR_FACE = "error-face";
const OK_FACE = "ok-face";

// Face functions
const LEARN = "learn-face";
const LOGIN = "face-login";
const CHECKIN = "checkin-hr";

const Wrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

const Control = styled.div`
  position: fixed;
  display: flex;
  right: 0;
  width: 20%;
  min-width: 130px;
  min-height: 130px;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 50px;
  box-sizing: border-box;
  flex-direction: column-reverse;
  @media (max-aspect-ratio: 1/1) {
    flex-direction: row;
    bottom: 0;
    width: 100%;
    height: 20%;
  }
  @media (max-width: 400px) {
    padding: 10px;
  }
`;
const StyledButton = styled.button`
  outline: none;
  color: white;
  opacity: 1;
  background: transparent;
  background-color: transparent;
  background-position-x: 0%;
  background-position-y: 0%;
  background-repeat: repeat;
  background-image: none;
  padding: 0;
  text-shadow: 0px 0px 4px black;
  background-position: center center;
  background-repeat: no-repeat;
  pointer-events: auto;
  cursor: pointer;
  z-index: 2;
  filter: invert(100%);
  border: none;
  &:hover {
    opacity: 0.7;
  }
`;
const TakePhotoButton = styled(StyledButton)`
  background: url('https://img.icons8.com/ios/50/000000/compact-camera.png');
  background-position: center;
  background-size: 50px;
  background-repeat: no-repeat;
  width: 80px;
  height: 80px;
  border: solid 4px black;
  border-radius: 50%;
  &:hover {
    background-color: rgba(0, 0, 0, 0.3);
  }
`;

const ChangeFacingCameraButton = styled(StyledButton)`
  background: url(https://img.icons8.com/ios/50/000000/switch-camera.png);
  background-position: center;
  background-size: 40px;
  background-repeat: no-repeat;
  width: 40px;
  height: 40px;
  padding: 40px;
  &:disabled {
    opacity: 0;
    cursor: default;
    padding: 60px;
  }
  @media (max-width: 400px) {
    padding: 40px 5px;
    &:disabled {
      padding: 40px 25px;
    }
  }
`;
const ImagePreview =  (image) => (styled.div<{ image }>`
  width: 120px;
  height: 120px;
  ${({ image }) => (image ? `background-image:  url(${image});` : '')}
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  @media (max-width: 400px) {
    width: 50px;
    height: 120px;
  }
`);
const FullScreenImagePreview = (image) => (styled.div<{ image }>`
  width: 100%;
  height: 100%;
  z-index: 100;
  position: absolute;
  background-color: black;
  ${({ image }) => (image ? `background-image:  url(${image});` : '')}
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`);
var detectFaces = false;
var modelsLoaded = false;
var face_function = "";

class FaceDetection extends React.Component {
  constructor(props) {
    super(props);
    if (window.location.pathname.startsWith("/configuracion")) {
      face_function = LEARN;
    } else if (window.location.pathname.startsWith("/entrar")) {
      // face_function = LOGIN;
      face_function = CHECKIN;
    } else if (window.location.pathname.startsWith("/fichar")) {
      face_function = CHECKIN;
    }
    // console.log("face function:", face_function);
    // /* //console.log("########## PROPS ###########");
    //console.log(props); */
    this.state = {
      learningFinished: false,
      faceName: "Adrian",
      sendingFaces: false,
      faces: [],
      angle: null,
      detectionTime: 1000,
      faceDirection: {},
      expectedFace: -1,
      directions: [
        CENTER_CENTER,
        CENTER_TOP,
        RIGHT_TOP,
        RIGHT_CENTER,
        RIGHT_BOTTOM,
        CENTER_BOTTOM,
        LEFT_BOTTOM,
        LEFT_CENTER,
        LEFT_TOP,
        HAPPY
      ],
      numberOfCameras: 0,
      image: null,
      showImage: false,
      devices: [],
      activeDeviceId: undefined,
      loginStatus: WAITING_FACE,
      username: ""
    };
    this.videoRef = React.createRef();
    this.canvasRef = React.createRef();
    this.imageRef = React.createRef();
    this.camera = React.createRef();

    this.addFace = this.addFace.bind(this);
    this.sendFaces = this.sendFaces.bind(this);
    this.getCheckList = this.getCheckList.bind(this);
    this.buildFaces = this.buildFaces.bind(this);
    this.setNumberOfCameras = this.setNumberOfCameras.bind(this);
    this.setImage = this.setImage.bind(this);
    this.setShowImage = this.setShowImage.bind(this);
    this.setActiveDeviceId = this.setActiveDeviceId.bind(this);
    this.startRecognition = this.startRecognition.bind(this);
    this.getFaceStatus = this.getFaceStatus.bind(this);
    this.getOverlayContent = this.getOverlayContent.bind(this);
    this.getLearnContent = this.getLearnContent.bind(this);
    this.getLoginContent = this.getLoginContent.bind(this);
    this.getLoginStatus = this.getLoginStatus.bind(this);
    this.detectFace = this.detectFace.bind(this);
  }
  componentDidMount() {
    // console.log("Face test v1.1");
    // this.startVideo();
    // videoRef && this.loadModels();
    this.faceDetection();
    (async () => {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(i => i.kind == 'videoinput');
      this.setDevices(videoDevices);
    })();
    this.startRecognition();
  }
  startRecognition() {
    detectFaces = true;
    // this.faceDetection(true);
  }
  stopRecognition() {
    detectFaces = false;
  }
  setNumberOfCameras(cameras) {
    this.setState({ numberOfCameras: cameras });
  }
  setImage(image) {
    this.setState({ image: image });
  }
  setShowImage(showImage) {
    this.setState({ showImage: showImage });
  }
  setActiveDeviceId(activeDeviceId) {
    this.setState({ activeDeviceId: activeDeviceId });
  }
  setDevices(devices) {
    this.setState({ devices: devices });
  }
  async loadModels(models) {
    // console.info("Loading models");
    if (faceapi) {
      // Load required models
      if (!models || models.includes("tinyFaceDetector")) {
        if (!faceapi.nets.tinyFaceDetector.isLoaded) {
          await faceapi.nets.tinyFaceDetector.loadFromUri('/models');
          // console.info("Model tinyFaceDetector loaded");
        } else {
          // console.info("Model tinyFaceDetector already loaded");
        }
      }
      if (!models || models.includes("faceLandmark68Net")){
        if (!faceapi.nets.faceLandmark68Net.isLoaded) {
          await faceapi.nets.faceLandmark68Net.loadFromUri('/models');
          // console.info("Model faceLandmark68Net loaded");
        } else {
          // console.info("Model faceLandmark68Net already loaded");
        }
      }
      if (!models || models.includes("faceRecognitionNet")){ 
        if (!faceapi.nets.faceRecognitionNet.isLoaded) {
          await faceapi.nets.faceRecognitionNet.loadFromUri('/models');
          // console.info("Model faceRecognitionNet loaded");
        } else {
          // console.info("Model faceRecognitionNet already loaded");
        }
      }
      if (!models || models.includes("faceExpressionNet")){ 
        if (!faceapi.nets.faceExpressionNet.isLoaded) {
          await faceapi.nets.faceExpressionNet.loadFromUri('/models');
          // console.info("Model faceExpressionNet loaded");
        } else {
          // console.info("Model faceExpressionNet already loaded");
        }
      }
      if (!models || models.includes("ssdMobilenetv1")) {
        if (!faceapi.nets.ssdMobilenetv1.isLoaded) {
          await faceapi.nets.ssdMobilenetv1.loadFromUri('/models');
          // console.info("Model ssdMobilenetv1 loaded");
        } else {
          // console.info("Model ssdMobilenetv1 already loaded");
        }
      }
      // console.info("Models loaded");
      return;
    } else {
      // "faceapi" isn't initialized
      console.info("faceapi isn't initialized");
      return;
    }
  }
  // loadModels = () => {
  //   Promise.all([
  //     faceapi.nets.tinyFaceDetector.loadFromUri('/models'),
  //     faceapi.nets.faceLandmark68Net.loadFromUri('/models'),
  //     faceapi.nets.faceRecognitionNet.loadFromUri('/models'),
  //     faceapi.nets.faceExpressionNet.loadFromUri('/models'),
  //     faceapi.nets.ssdMobilenetv1.loadFromUri('/models')
  //   ]).then(() => {
  //     this.faceDetection();
  //     // train();
  //   });
  // };
  startVideo = () => {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then(currentStream => {
        videoRef.current.srcObject = currentStream;
      })
      .catch(err => {
        console.error(err);
      });
  };
  async canvasFromBase64(base64) {
      var imgBase64 = base64.split(";");
      if (imgBase64.length > 1) imgBase64 = imgBase64[1];
      imgBase64 = imgBase64.replace("base64,", "").trim();
      const buffer = Buffer.from(imgBase64, "base64");
      const img = await canvas.loadImage(buffer);
      return img;
  }
  faceDetection = async (force) => {
    if (face_function !== CHECKIN) await this.loadModels();
    modelsLoaded = true;
    setInterval(async () => {
      // console.info("In faceDetection. Should we proceed?");
      if (this.state.isRecognizingFace) return;
      if (detectFaces || force) {
        if (face_function === LOGIN && this.state.loginStatus !== WAITING_FACE)
          return;
        // console.info("Yes, starting face detection");
        if (camera.current) {
          let photo = camera.current.takePhoto();
          // console.info("Photo taken", photo);
          imageRef.current.src = photo;
          // console.log("foto obtenida", photo);
          if (face_function === LOGIN || face_function === CHECKIN) {
            this.detectFace(photo);
            return;
          }
          // let img = await this.canvasFromBase64(photo);
          // let img = React.createElement("img", {
          //   src: photo
          // });
          // console.info("imageRef", imageRef);
          const detections = await faceapi
            .detectAllFaces("taken_photo", new faceapi.TinyFaceDetectorOptions())
            .withFaceLandmarks()
            .withFaceExpressions();
          // const detections = await faceapi.detectAllFaces(videoRef.current, new faceapi.TinyFaceDetectorOptions());
          if (detections && detections[0]) {
            // console.log("detections", detections);
            if (detections.length === 1) {
              let detection = detections[0];
              if (face_function === LEARN) {
                let facesLength = Object.keys(this.state.faces || []).length;
                let expectedFace = facesLength;
                expectedFace =
                  expectedFace >= 0
                    ? this.state.directions[facesLength]
                    : "";
                // console.log("expectedFace", expectedFace);
                if (expectedFace === HAPPY) {
                  if (
                    this.isHappy(detection.expressions) &&
                    !this.state.faces[HAPPY]
                  ) {
                    this.addFace(photo, HAPPY);
                  }
                } else {
                  let direction = this.calculateFaceDirection(detection);
                  // console.log("direction, expectedFace", {direction: direction, expectedFace: expectedFace});
                  if (direction == expectedFace) {
                    await this.addFace(photo, direction);
                  }
                }
              } else if (face_function === LOGIN) {
                // this.addFace(photo, HAPPY);
                this.recognizeFace(photo);
              }
            } else {
              console.error("Found more than 1 face");
            }
          }
        }
      } else {
        // console.info("Nope, let's try again later");
      }
    }, this.state.detectionTime);
  };
  async addFace(imgBase64, direction) {
    // console.log(`Adding photo -> ${direction}`);
    let faces = this.state.faces;
    if (!faces) faces = [];
    // console.log(`Adding photo (faces)`, faces);
    let facesLength = Object.keys(this.state.faces || []).length;
    // console.log(`Adding photo (facesLength)`, facesLength);
    if (faces[direction]) return;
    faces[direction] = imgBase64;
    if (facesLength < 10) {
      this.setState({
        faces: faces
      });
      // If we want the whole frame
      // detections = [new faceapi.Rect(0, 0, 640, 480)];

      // If we want the real face
      // detections.map(res => res.detection)

      // const faceImages = await faceapi.extractFaces(video, detections);
      // if (faceImages.length == 0) {
      //   console.log("Face not found");
      // } else {
      //   this.setState({ expectedFace: ++(this.state.faces.length - 1) });
      //   faceImages.forEach(cnv => {
      //     // outputImage.src = cnv.toDataURL();
      //     // let base64 = cnv.toDataURL();
      //     faces[direction] = imgBase64;
      //     this.setState({ faces: faces });
      //     // this.addFace(base64, direction);
      //   });
      // }
    }
  }
  async detectFace(imgBase64) {
    // if (this.state.loginStatus === RECOGNIZING_FACE) return;
    if (this.state.isRecognizingFace) return;
    this.setState({
      isRecognizingFace: true
    });
    let face = await this.compressImage(imgBase64);
    this.props.userData
      .detectFace(face)
      .then(result => {
        if (result.ok) {
          if (result.detection) {
            if (!result.multiple) {
              this.recognizeFace(result.uuid);
            } else {
              this.setState({
                isRecognizingFace: false
              });
              console.error("Error al detectar la cara: Hay varias caras");
            }
          } else {
            this.setState({
              isRecognizingFace: false
            });
            console.error("Error al detectar la cara: No hay cara");
          }
        } else {
          this.setState({
            isRecognizingFace: false
          });
          // Error 😨
          console.error("Error al detectar la cara: " + result.error);
          // this.setState({
          //   loginStatus: ERROR_FACE
          // });
          // setTimeout( function() {
          //   this.setState({
          //     loginStatus: WAITING_FACE
          //   })
          // }.bind(this), 2000);
        }
      })
      .catch((error) => {
        this.setState({
          isRecognizingFace: false
        });
        // Error 😨
        console.error("Error al detectar la cara: " + error.message);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
  }
  async recognizeFace(face) {
    if (this.state.loginStatus === RECOGNIZING_FACE) return;
    this.setState({
      loginStatus: RECOGNIZING_FACE
    });
    // let face = await this.compressImage(imgBase64);
    this.props.userData
      .faceLogin(face)
      .then(result => {
        if (result.ok) {
          let name = result.user.field_nombre_completo.und[0].value;
          if (name) name = name.split(" ");
          if (name && name.length > 0) name = name[0];
          this.setState({
            loginStatus: OK_FACE,
            username: name,
            loginResult: result
          });
          setTimeout( function() {
            let input = {
              data: this.state.loginResult,
              faceLogin: true
            };
            // console.log("Before calling godMode (input)", input);
            this.props.godMode(input, false, face);
          }.bind(this), 2000);
        } else {
          this.setState({
            loginStatus: ERROR_FACE
          });
          setTimeout( function() {
            this.setState({
              loginStatus: WAITING_FACE,
              isRecognizingFace: false
            })
          }.bind(this), 2000);
        }
      })
      .catch((error) => {
        this.setState({
          sendingFaces: false
        });
        // Error 😨
        console.error("Error al reconocer las caras: " + error.message);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
  }
  async compressImage(imgBase64) {
    var options = {
      maxSizeMB: 0.20, // 200KB
      maxWidthOrHeight: 1920,
      useWebWorker: true
      // onProgress: this.imageUploadStatus
    };
    // Gets compressed base64(from File(from original base64))
    return await imageCompression.getDataUrlFromFile(
      await imageCompression(
        await imageCompression.getFilefromDataUrl(imgBase64, "image.png"),
        options
      )
    );
  }
  async compressFaces(faces) {
    // console.log("Starting faces compression...");
    // console.log("faces", faces);
    let directions = Object.keys(faces);
    let compressedFaces = [];
    // var options = {
    //   maxSizeMB: 0.05, // 50KB
    //   maxWidthOrHeight: 1920,
    //   useWebWorker: true
    //   // onProgress: this.imageUploadStatus
    // };

    compressedFaces = await Promise.all(
      directions.map(async direction => {
        let face = faces[direction];
        return await this.compressImage(face);
        // Gets compressed base64(from File(from original base64))
        // return await imageCompression.getDataUrlFromFile(
        //   await imageCompression(
        //     await imageCompression.getFilefromDataUrl(face, "image.png"),
        //     options
        //   )
        // );
      })
    );
    // console.log("Faces compression ready!");
    return compressedFaces;
  }
  async sendFaces() {
    let sendingFaces = this.state.sendingFaces;
    if (sendingFaces) return;
    let faces = this.state.faces;
    if (!faces) faces = [];
    let facesDirections = Object.keys(faces);
    if (facesDirections.length < 10) {
      return;
    }
    sendingFaces = true;
    this.setState({
      sendingFaces: sendingFaces
    });
    // let facesImgs = facesDirections.map(direction => {
    //   let face = faces[direction];
    //   return face;
    // });
    faces = await this.compressFaces(faces);
    this.props.userData.addFaces(faces, this.state.faceName).then(result => {
      this.setState({
        sendingFaces: false
      });
      // console.log("Result addFace", result);
      if (result.ok) {
        this.setState({
          learningFinished: true
        });
      } else {
        console.error("Something went wrong: " + result.error);
      }
    })
    .catch((error) => {
      this.setState({
        sendingFaces: false
      });
      // Error 😨
      console.error("Error al añadir las caras: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
    // filter.page = filter.page - 1;
  }
  radians_to_degrees(radians) {
    let pi = Math.PI;
    return radians * (180 / pi);
  }
  radians(a1, a2, b1, b2) {
    return this.radians_to_degrees(Math.atan2(b2 - a2, b1 - a1));
  }
  calculateFaceAngle(mesh) {
    // const radians = (a1, a2, b1, b2) => this.radians(a1, a2, b1, b2);
    const radians = (a1, a2, b1, b2) => Math.atan2(b2 - a2, b1 - a1);

    let angle = {
      roll: null,
      pitch: null,
      yaw: null
    };

    if (!mesh || !mesh._positions || mesh._positions.length !== 68)
      return angle;
    let pt = mesh._positions;

    // roll is face lean left/right
    // comparing x,y of outside corners of leftEye and rightEye
    angle.roll = radians(pt[36]._x, pt[36]._y, pt[45]._x, pt[45]._y);

    // yaw is face turn left/right
    // comparing x distance of bottom of nose to left and right edge of face
    //       and y distance of top    of nose to left and right edge of face
    // precision is lacking since coordinates are not precise enough
    angle.pitch = radians(
      pt[30]._x - pt[0]._x,
      pt[27]._y - pt[0]._y,
      pt[16]._x - pt[30]._x,
      pt[27]._y - pt[16]._y
    );

    // pitch is face move up/down
    // comparing size of the box around the face with top and bottom of detected landmarks
    // silly hack, but this gives us face compression on y-axis
    // e.g., tilting head up hides the forehead that doesn't have any landmarks so ratio drops
    // value is normalized to range, but is not in actual radians
    let bottom = pt.reduce((prev, cur) => (prev < cur._y ? prev : cur._y), +Infinity);
    let top = pt.reduce((prev, cur) => (prev > cur._y ? prev : cur._y), -Infinity);
    angle.yaw = 10 * (mesh._imgDims._height / (top - bottom) / 1.45 - 1);

    return angle;
  }
  calculateNoseCenter(noseedge, box) {
    let xAxis = null;
    let yAxis = null;
    const xLowLimit = 0.40; // Below is looking left
    const xHighLimit = 0.60; // Over is looking right
    const yLowLimit = 0.40; // Below is looking up
    const yHighLimit = 0.50; // Over is looking down
    // 0.40 < xAxis < 0.60 -> Centro
    xAxis = (noseedge.x - box.x) / box.width;
    // 0.40 < yAxis < 0.60 -> Centro
    yAxis = (noseedge.y - box.y) / box.height;

    let verticalPrediction = "";
    if (yAxis > yHighLimit) {
      verticalPrediction = "Abajo";
    } else if (yAxis > yLowLimit) {
      verticalPrediction = "Centro";
    } else {
      verticalPrediction = "Arriba";
    }

    let horizontalPrediction = "";
    if (xAxis > xHighLimit) {
      horizontalPrediction = "Derecha";
    } else if (xAxis > xLowLimit) {
      horizontalPrediction = "Centro";
    } else {
      horizontalPrediction = "Izquierda";
    }
    return {
      xAxis: xAxis,
      yAxis: yAxis,
      horizontalPrediction: horizontalPrediction,
      verticalPrediction: verticalPrediction
    };
  }
  isHappy(expressions) {
    return expressions.happy > 0.9;
  }
  calculateFaceDirection(detection) {
    let landmarks = detection.landmarks;
    let nose = landmarks.getNose();
    let faceDirection = this.getFaceDirectionFromNose(nose, detection.detection.box);
    this.setState({ faceDirection: faceDirection });
    faceDirection = faceDirection.direction;
    return faceDirection;
  }
  getFaceDirectionFromNose(nose, box) {
    let noseedge = nose[3];
    let xAxis = null;
    let yAxis = null;
    const xLowLimit = 0.40; // Below is looking left
    const xHighLimit = 0.60; // Over is looking right
    const yLowLimit = 0.40; // Below is looking up
    const yHighLimit = 0.50; // Over is looking down
    // 0.40 < xAxis < 0.60 -> Centro
    xAxis = (noseedge.x - box.x) / box.width;
    // 0.40 < yAxis < 0.60 -> Centro
    yAxis = (noseedge.y - box.y) / box.height;

    let verticalPrediction = "";
    if (yAxis > yHighLimit) {
      verticalPrediction = "bottom";
    } else if (yAxis > yLowLimit) {
      verticalPrediction = "center";
    } else {
      verticalPrediction = "top";
    }

    let horizontalPrediction = "";
    if (xAxis > xHighLimit) {
      // It should be "right", but as it wil be used with frontal cameras it is "left"
      horizontalPrediction = "left";
    } else if (xAxis > xLowLimit) {
      horizontalPrediction = "center";
    } else {
      // It should be "left", but as it wil be used with frontal cameras it is "right"
      horizontalPrediction = "right";
    }
    return {
      direction: horizontalPrediction + verticalPrediction,
      directionData: {
        xAxis: xAxis,
        yAxis: yAxis,
        horizontalPrediction: horizontalPrediction,
        verticalPrediction: verticalPrediction
      }
    };
  }
  getTop(l) {
    return l.map((a) => a.y).reduce((a, b) => Math.min(a, b));
  }
  getBottom(l) {
    return l.map((a) => a.y).reduce((a, b) => Math.max(a, b));
  }
  getMeanPosition(l) {
    return l.map((a) => [a.x, a.y]).reduce((a, b) => [a[0] + b[0], a[1] + b[1]]).map((a) => a / l.length);
  }
  getFaceStatusIcon(success, level) {
    if (level === 0) return <i className={"now-ui-icons arrows-1_cloud-upload-94 current"} />;
    return <i className={"now-ui-icons " + (success ? "ui-1_check success" : "ui-1_simple-remove error")} />;
  }
  getFaceStatus(direction) {
    let facesLength = Object.keys(this.state.faces || []).length;
    let level = Math.abs(facesLength - direction);
    if (direction < 0) return null;
    if (direction > this.state.directions.length - 1) return null;
    let currentDirection = this.state.directions[direction];
    let directionLiteral = {
      [CENTER_CENTER]: "Centro",
      [CENTER_TOP]: "Arriba",
      [RIGHT_TOP]: "Arriba derecha",
      [RIGHT_CENTER]: "Derecha",
      [RIGHT_BOTTOM]: "Derecha abajo",
      [CENTER_BOTTOM]: "Abajo",
      [LEFT_BOTTOM]: "Abajo izquierda",
      [LEFT_CENTER]: "Izquierda",
      [LEFT_TOP]: "Arriba izquierda",
      [HAPPY]: "Sonríe 😊"
    };
    // console.info("currentDirection", currentDirection);
    // console.info("directionLiteral", directionLiteral);
    // console.info("directionLiteral[currentDirection]", directionLiteral[currentDirection]);
    return (
      <Col xs={12} className="text-left">
        <span className={"face-status level-" + level}>
          {this.getFaceStatusIcon(this.state.faces[currentDirection], level)}{" "}
          {directionLiteral[currentDirection]}
        </span>
      </Col>
    );
  }
  getCheckList() {
    let facesLength = Object.keys(this.state.faces || []).length;
    if (facesLength >= 10) return;
    return (
      <Col xs={12} id="face-status-list">
        <Row>
          {this.getFaceStatus(facesLength - 2)}
          {this.getFaceStatus(facesLength - 1)}
          {this.getFaceStatus(facesLength)}
          {this.getFaceStatus(facesLength + 1)}
          {this.getFaceStatus(facesLength + 2)}
        </Row>
      </Col>
    );
  }
  buildFaces() {
    let faces = this.state.faces;
    if (!faces) return;
    let facesImg = Object.keys(faces).map(direction => {
      let face = faces[direction];
      return (
        <Col key={direction + "-face"}>
          <img src={face} className="miniface" />
        </Col>
      );
    });
    return <Row>{facesImg}</Row>;
  }
  getLearnContent() {
    if (!this.state.learningFinished) {
      return (
        <div>
          <Row>{this.getCheckList()}</Row>
          {(!detectFaces || Object.keys(this.state.faces).length >= 10) && <Row style={{ margin: "0 auto" }}>
            <Col xs={12}>
              {/* <Input
                // disabled={!isAdmin}
                type="text"
                placeholder="Nombre de la cara"
                value={this.state.faceName}
                onChange={event => {
                  let newValue = event.target.value;
                  this.setState({ faceName: newValue });
                }}
              />
              {!detectFaces && (
                <Button
                  color={"primary"}
                  onClick={async () => {
                    this.startRecognition();
                  }}
                >
                  Empezar
                </Button>
              )} */}
              {/* <Button
                onClick={() => {
                  this.setState({
                    faces: []
                  });
                }}
              >
                Reiniciar
              </Button> */}
              {this.state.faces && Object.keys(this.state.faces).length >= 10 && (
                <Button
                  disabled={this.state.sendingFaces}
                  color={"primary"}
                  onClick={() => {
                    this.sendFaces();
                  }}
                >
                  {this.state.sendingFaces ? (
                    <span>
                      <i className="now-ui-icons arrows-1_refresh-69 spin" />{" "}
                      Enviando
                    </span>
                  ) : (
                    "Enviar caras"
                  )}
                </Button>
              )}
              {this.state.numberOfCameras > 1 && (
                <ChangeFacingCameraButton
                  disabled={this.state.numberOfCameras <= 1}
                  onClick={() => {
                    if (camera.current) {
                      // const result = camera.current.switchCamera();
                    }
                  }}
                />
              )}
              <div style={{ display: "block" }}>Face v1.1.wait</div>
            </Col>
          </Row>}
        </div>
      );
    } else {

    }
  }
  getLoginStatusIcon(status) {
    let icon = null;
    switch (status) {
      case WAITING_FACE:
        icon = "users_circle-08";
        break;
      case RECOGNIZING_FACE:
        icon = "loader_refresh spin";
        break;
      case ERROR_FACE:
        icon = "ui-1_simple-remove";
        break;
      case OK_FACE:
        icon = "ui-1_check";
        break;
      default:
        icon = "users_circle-08";
        break;
    }
    return <i className={status + " now-ui-icons " + icon} />;
  }
  getLoginStatus(status) {
    let result = null;
    switch (status) {
      case WAITING_FACE:
        result = "Mírame";
        break;
      case RECOGNIZING_FACE:
        result = "¿Quién eres?";
        break;
      case ERROR_FACE:
        result = "No lo sé 😥";
        break;
      case OK_FACE:
        result = "¡Hola, " + this.state.username + "!😊";
        break;
      default:
        result = "Mírame";
        break;
    }
    return (
      <Col xs={12} className="text-left">
        <span id="facelogin-status" className={"face-status level-0"}>
          {this.getLoginStatusIcon(this.state.loginStatus)} {result}
        </span>
      </Col>
    );
  }
  getLoginContent() {
    return (
      <div>
        <Row>{this.getLoginStatus(this.state.loginStatus)}</Row>
      </div>
    );
  }
  getOverlayContent() {
    if (!modelsLoaded) {
      return (
        <Col xs={12} id="face-status-list">
          <Row>
            <Col xs={12} className="text-left">
              <span className={"face-status level-0"}>
                <i className="now-ui-icons arrows-1_refresh-69 spin" />{" "}
                Cargando
              </span>
            </Col>
          </Row>
        </Col>
      );
    }
    switch (face_function) {
      case LEARN:
        return this.getLearnContent();
      case LOGIN:
        return this.getLoginContent();
      case CHECKIN:
        return this.getLoginContent();
      default:
        return this.getLearnContent();
    }
  }
  render() {
    return (
      <Wrapper>
        <Camera
          ref={camera}
          aspectRatio="cover"
          numberOfCamerasCallback={i => this.setNumberOfCameras(i)}
          videoSourceDeviceId={this.state.activeDeviceId}
          errorMessages={{
            noCameraAccessible: 'No camera device accessible. Please connect your camera or try a different browser.',
            permissionDenied: 'Permission denied. Please refresh and give camera permission.',
            switchCamera:
              'It is not possible to switch camera to different one because there is only one video device accessible.',
            canvas: 'Canvas is not supported.',
          }}
        />
        <div id="face-overlay">{this.getOverlayContent()}</div>
        <img id="taken_photo" style={{ display: "none" }} ref={imageRef} />
      </Wrapper>
    );
  }
}

export default FaceDetection;



// WEBPACK FOOTER //
// ./src/views/FaceDetection/FaceDetection.jsx